'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = IconComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function IconComponent(props) {
	var _classNames;

	if (props.visible === false) return null;

	var showStyle = props.showStyle,
	    fontFamily = props.fontFamily,
	    other = (0, _objectWithoutProperties3.default)(props, ['showStyle', 'fontFamily']);


	if (props.disabled) {
		showStyle = 'disabled';
	}

	var className = 'mk-icon';

	/*if (fontFamily == 'awesome') {
 	className = classNames({
 		[className]: true,
 		[`mkicon--${showStyle}`]: !!showStyle,
 		[props.className]: !!props.className
 	})
 	return <FA {...other} className={className} name={props.type} />
 }*/

	className = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, className, true), (0, _defineProperty3.default)(_classNames, fontFamily, !!fontFamily), (0, _defineProperty3.default)(_classNames, fontFamily + '-' + props.type, !!fontFamily), (0, _defineProperty3.default)(_classNames, 'mkicon--' + showStyle, !!showStyle), (0, _defineProperty3.default)(_classNames, props.className, !!props.className), _classNames));

	return _react2.default.createElement(_icon2.default, (0, _extends3.default)({}, other, { className: className }));
}
//import FA from 'react-fa'
module.exports = exports['default'];